import { get } from "lodash-es";
import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";
import { getMomentTz } from "../../../../services/TimeService";
import { Job } from "../models/Job";

const moment = getMomentTz();

export const GetJobsStatus = async () => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[SYSTEM].[GetJobsStatus]", []);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []);

		rows = rows.map((job: Job) => ({
			...job,
			LastStarted: job.LastStarted
				? moment.utc(job["LastStarted"]).toDate()
				: null,
			LastContact: job.LastContact
				? moment.utc(job["LastContact"]).toDate()
				: null,
			LastCounter: job.LastCounter
				? moment.utc(job["LastCounter"]).toDate()
				: null,
			StartTime: job.StartTime ? moment.utc(job["StartTime"]).toDate() : null,
			NextExecutionTime: job.NextExecutionTime
				? moment.utc(job["NextExecutionTime"]).toDate()
				: null,
			LastExecutionTime: job.LastExecutionTime
				? moment.utc(job["LastExecutionTime"]).toDate()
				: null,
		}));

		return {
			ok: true,
			data: rows,
		};
	} else {
		return {
			ok: false,
			message: resp.message,
		};
	}
};

export const upsertJob = async (job: Job) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "JobId", value: job.JobId },
		{ name: "sProcedure", value: job.sProcedure },
		{ name: "StartTime", value: job.StartTime },
		{ name: "PeriodTime", value: job.PeriodTime },
		{ name: "RestartAfterFailure", value: job.RestartAfterFailure },
	];

	return await apiService.callV2("[SYSTEM].[UpsertJob]", parameters);
};

export const SetJobEnable = async (
	enabled: boolean | null,
	jobId: number | null,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Enabled", value: enabled ?? true },
		{ name: "JobId", value: jobId },
	];

	return await apiService.callV2("[SYSTEM].[SetJobEnable]", parameters);
};

export const RestartJob = async (jobId: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "JobId", value: jobId }];

	return await apiService.callV2("[SYSTEM].[RestartJob]", parameters);
};
